<template>
    <div class="resume-item-module">
        <h1 class="module-title">附件上传</h1>
        <attach :init="data" ref="attach" :rid="rid"></attach>
    </div>
</template>
<script type="text/javascript">
    import Attach from './items/attach'

    export default {
        props: {
            data: [Object, Array],
            rid: [Number, String]
        },
        data () {
            return {}
        },
        components: {
            Attach
        }
    }
</script>
<style type="text/css" lang="scss">
    @import "~variable";
</style>


// WEBPACK FOOTER //
// attachModule.vue?6853e839